module.exports = __webpack_public_path__ + "img/213w.876e634.jpg";